import { configFetch as fetch } from '@laigu/utils';

export const getFeConfigApi = ({ keys }) => {
  return fetch({
    url: '/agent/fe_config',
    method: 'POST',
    data: {
      keys
    }
  });
};

export const updateFeConfigApi = ({ key, data }) => {
  return fetch({
    url: '/agent/fe_config',
    method: 'PUT',
    data: {
      key,
      value: data
    }
  });
};
